export const articles = [
  {
    slug: 'autumn-2026-trends',
    title: '2026秋季穿搭趋势：温柔与力量并存',
    excerpt: '本季以柔和的轮廓与大胆的配色相融合，复古元素与现代剪裁碰撞出全新的时尚语言。从秀场到街头，带你掌握这一季的穿搭密码。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20autumn%20fashion%20editorial%20with%20warm%20toned%20clothing%20in%20camel%20and%20burgundy%2C%20soft%20natural%20lighting%2C%20minimalist%20studio%20setup%2C%20fashion%20magazine%20style%20photography%2C%20cozy%20textures%20and%20layered%20looks&width=800&height=500&seq=article-autumn-01&orientation=landscape',
    date: '2026-08-05',
    author: '蘑菇编辑部',
    category: '穿搭',
    content: `
      <h2>温柔力量：2026秋季穿搭关键词</h2>
      <p>当秋天的第一缕微风吹过，衣柜里的色彩也随之悄然变化。2026年秋季时尚界呈现出一种独特的平衡感——既有柔和流畅的轮廓线条，又有充满力量的色彩表达。这一季的设计师们不约而同地在"温柔"与"力量"之间找到了一个绝妙的平衡点。</p>
      
      <h3>一、核心色彩趋势</h3>
      <p>本季的主色调围绕温暖的大地色系展开。驼色、焦糖色和奶油白成为当之无愧的主角，而深莓果红和橄榄绿则作为点缀色彩，为整体造型增添层次感。</p>
      <p>值得关注的是，柔和的莫兰迪色调在本季依然占据重要位置。烟灰粉、雾霾蓝、鼠尾草绿等低饱和度色彩，完美诠释了"温柔的力量"这个主题。</p>
      
      <h3>二、关键单品推荐</h3>
      <p><strong>1. 宽松剪裁的西装外套</strong>——不再是传统的修身版型，oversized的廓形让职场穿搭多了几分随性与从容。搭配同色系阔腿裤，轻松打造高级感十足的total look。</p>
      <p><strong>2. 针织连衣裙</strong>——柔软的针织面料贴合身体曲线，却又不失舒适感。选择一件剪裁考究的针织长裙，单穿或叠搭外套都能展现优雅气质。</p>
      <p><strong>3. 高腰阔腿裤</strong>——延续了前几季的热度，本季的阔腿裤在面料选择上更加多元化。从垂坠感十足的真丝到挺括的羊毛混纺，不同材质带来截然不同的风格表达。</p>
      
      <h3>三、穿搭灵感</h3>
      <p>将温柔的针织衫与利落的西装裤搭配，再用一条亮色丝巾作为点缀，这就是本季最经典的穿搭公式。想要更加日常的造型？一件oversized的棉质衬衫搭配高腰直筒牛仔裤，简单又时髦。</p>
      
      <h3>四、配饰点睛</h3>
      <p>造型感十足的金属配饰将成为本季的亮点。粗链条项链、大号耳环以及多层叠戴的手链，都能为基础穿搭增添不少时尚感。包袋方面，柔软的大号托特包和复古风格的马鞍包都是不错的选择。</p>
      
      <p>总的来说，2026秋季的时尚关键词是"自在"。不必刻意追求某种风格，找到让自己感到舒适且自信的穿搭方式，才是真正的时尚。</p>
    `,
    tags: ['秋季穿搭', '时尚趋势', '穿搭推荐', '2026秋冬'],
  },
  {
    slug: 'capsule-wardrobe-guide',
    title: '极简衣橱指南：30件单品穿出100种风格',
    excerpt: '学会胶囊衣橱法则，用最少的单品创造最多的搭配可能。从基础款到点睛配饰，打造属于你的高效衣橱。',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20capsule%20wardrobe%20display%20with%20neutral%20toned%20clothing%20items%20arranged%20neatly%2C%20warm%20beige%20and%20cream%20colors%2C%20clean%20studio%20background%2C%20soft%20lighting%2C%20fashion%20editorial%20photography%2C%20organized%20minimal%20aesthetic&width=800&height=500&seq=article-capsule-02&orientation=landscape',
    date: '2026-07-28',
    author: '蘑菇编辑部',
    category: '穿搭',
    content: `
      <h2>什么是胶囊衣橱？</h2>
      <p>胶囊衣橱这个概念最早由伦敦精品店店主Susie Faux在1970年代提出。核心理念是：精选少量高质量、经典百搭的单品，通过巧妙的排列组合，创造出丰富多样的穿搭效果。</p>
      
      <h3>打造胶囊衣橱的三大原则</h3>
      <p><strong>原则一：色彩统一</strong>——选择2-3个主色调（建议中性色如黑、白、灰、驼色），再搭配1-2个点缀色。确保所有单品之间可以自由搭配。</p>
      <p><strong>原则二：注重品质</strong>——与其购买十件快时尚单品，不如投资一件高质量的基础款。好的面料和剪裁能让你穿得更久、更自信。</p>
      <p><strong>原则三：遵循二八法则</strong>——80%为基础款，20%为设计款。基础款保证日常穿搭不出错，设计款让造型更有亮点。</p>
      
      <h3>30件单品清单</h3>
      <p>上衣类（8件）：白衬衫、条纹衬衫、纯色T恤×2、针织衫×2、丝质衬衫、卫衣</p>
      <p>下装类（6件）：直筒牛仔裤、阔腿裤、黑色烟管裤、A字半裙、百褶裙、短裤</p>
      <p>外套类（4件）：风衣、西装外套、牛仔夹克、羊毛大衣</p>
      <p>连衣裙（3件）：小黑裙、碎花连衣裙、衬衫裙</p>
      <p>鞋履（5件）：小白鞋、黑色短靴、尖头单鞋、乐福鞋、凉鞋</p>
      <p>包袋配饰（4件）：托特包、斜挎包、丝巾、简约腰带</p>
      
      <h3>搭配示例</h3>
      <p>掌握了以上30件单品，你可以轻松搭配出包括通勤、约会、周末休闲、正式场合在内的多种风格。一件白衬衫，可以搭配西装裤通勤、搭配牛仔裤休闲、搭配半身裙约会——一件单品，三种场景，三种风格。</p>
    `,
    tags: ['胶囊衣橱', '极简穿搭', '基础款搭配', '衣橱整理'],
  },
  {
    slug: 'skincare-routine-autumn',
    title: '换季护肤全攻略：让你的肌肤喝饱水',
    excerpt: '夏秋交替时节，肌肤容易出现干燥、敏感等问题。资深美容编辑为你整理了一套科学有效的换季护肤方案。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20skincare%20products%20arranged%20on%20marble%20surface%20with%20natural%20botanical%20elements%2C%20warm%20soft%20lighting%2C%20clean%20aesthetic%2C%20beauty%20editorial%20photography%2C%20minimalist%20luxury%20style%2C%20cream%20and%20glass%20bottles&width=800&height=500&seq=article-skincare-03&orientation=landscape',
    date: '2026-07-20',
    author: '蘑菇编辑部',
    category: '美妆',
    content: `
      <h2>换季护肤的黄金法则</h2>
      <p>每到季节交替，肌肤状态总会出现波动。干燥起皮、莫名泛红、护肤品吸收变差……这些都是肌肤在向你发出的求救信号。掌握以下护肤法则，让你的肌肤平稳度过换季期。</p>
      
      <h3>一、温和清洁是第一要务</h3>
      <p>夏秋交替，皮肤油脂分泌开始减少。此时如果继续使用夏季的强力清洁产品，很容易破坏皮肤屏障。建议将洁面产品换成氨基酸类温和配方，每天早晚各一次即可，避免过度清洁。</p>
      
      <h3>二、补水保湿层层递进</h3>
      <p>保湿不是简单地涂一层面霜就完事了。科学保湿应该遵循"水-精华-乳液/面霜"的层次递进原则。先用化妆水为肌肤补充水分，再用水性精华进行深层补水，最后用油性面霜锁住水分。</p>
      
      <h3>三、修复屏障是关键</h3>
      <p>含有神经酰胺、角鲨烷、泛醇等成分的护肤品，可以帮助修复受损的皮肤屏障。选择一款含有这些修复成分的精华或面霜，坚持使用两周以上，肌肤的锁水能力和耐受力都会明显提升。</p>
      
      <h3>四、防晒不可松懈</h3>
      <p>秋天的紫外线强度并不比夏天弱多少。UVA可以穿透云层和玻璃，是导致皮肤光老化的元凶。秋季防晒依然要做到位，SPF30 PA+++以上的防晒产品是日常标配。</p>
      
      <h3>五、调整饮食作息</h3>
      <p>外用的护肤品效果有限，内调才是根本。多喝水、多吃富含维生素C和E的食物、保证充足睡眠，这些看似老生常谈的建议，却是最有效的护肤法则。</p>
    `,
    tags: ['换季护肤', '保湿补水', '护肤攻略', '秋季护肤'],
  },
  {
    slug: 'office-style-guide',
    title: '职场穿搭进阶指南：从新人到高管',
    excerpt: '职场穿搭不仅是外在形象，更是你专业态度的无声表达。不同阶段的职场着装心法，助你在职场中穿出自信与力量。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20professional%20women%20office%20style%20with%20tailored%20neutral%20toned%20outfits%2C%20warm%20beige%20and%20cream%20palette%2C%20soft%20natural%20lighting%2C%20modern%20minimalist%20office%20setting%2C%20fashion%20editorial%20photography&width=800&height=500&seq=article-office-04&orientation=landscape',
    date: '2026-07-15',
    author: '蘑菇编辑部',
    category: '穿搭',
    content: `
      <h2>职场穿搭：无声的自我表达</h2>
      <p>在职场中，穿搭是你在开口之前传递给对方的第一印象。不同的职业阶段，穿搭策略也有所不同。以下是一份从职场新人到管理层的完整穿搭指南。</p>
      
      <h3>职场新人期：得体比时髦更重要</h3>
      <p>刚入职场，建立专业可信的形象是第一优先级。选择剪裁合体的基础款为主，颜色以黑、白、灰、藏蓝、驼色为佳。一两件有设计感的配饰作为点缀即可，避免过于花哨的款式。</p>
      
      <h3>成长期：找到自己的风格标签</h3>
      <p>工作3-5年后，你已经有了基本的职场穿搭认知。这个阶段可以开始尝试建立个人风格——是简约干练的中性风，还是优雅温柔的女性风？找到让你感到舒适且自信的风格方向。</p>
      
      <h3>管理层：用穿搭传递权威感</h3>
      <p>当你步入管理层，穿搭需要传递出更多的权威感和领导力。优质面料、精致剪裁、经典款式是你的首选。西装套装、质感衬衫、丝质内搭是衣橱必备。细节决定成败——一只优质腕表、一双考究的皮鞋，都能让你的专业形象更加出彩。</p>
    `,
    tags: ['职场穿搭', '通勤风格', '职业形象', '穿搭指南'],
  },
  {
    slug: 'sustainable-fashion',
    title: '可持续时尚：美丽不应该是地球的负担',
    excerpt: '当快时尚对环境的影响日益凸显，越来越多的品牌和消费者开始关注可持续时尚。了解如何在不牺牲风格的同时，做出更环保的时尚选择。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20sustainable%20fashion%20concept%20with%20natural%20fabric%20textiles%20in%20warm%20earth%20tones%2C%20organic%20cotton%20and%20linen%2C%20soft%20natural%20lighting%2C%20minimalist%20eco%20friendly%20aesthetic%2C%20editorial%20photography&width=800&height=500&seq=article-sustainable-05&orientation=landscape',
    date: '2026-07-08',
    author: '蘑菇编辑部',
    category: '时尚',
    content: `
      <h2>什么是可持续时尚？</h2>
      <p>可持续时尚不仅仅是一种潮流，更是一种负责任的消费态度。它涵盖了从原料选择、生产工艺、供应链透明到消费者使用和回收的全过程，旨在减少时尚产业对环境的负面影响。</p>
      
      <h3>如何做一个可持续的时尚消费者？</h3>
      <p><strong>买少但买好</strong>——投资经久耐穿的高质量单品，而不是频繁购买快时尚产品。一件优质的基础款可以穿很多年，从长远来看既省钱又环保。</p>
      <p><strong>选择天然面料</strong>——有机棉、亚麻、天丝、羊毛等天然可降解面料，相比化纤面料对环境更加友好。</p>
      <p><strong>支持环保品牌</strong>——越来越多的时尚品牌开始推行可持续理念，从使用再生面料到透明的供应链管理，选择这些品牌就是在支持一个更好的时尚未来。</p>
      <p><strong>二手与交换</strong>——二手衣物交易和交换派对是很棒的环保选择。给旧衣物第二次生命，既减少浪费，又可能淘到独一无二的复古好物。</p>
      
      <h3>蘑菇网的可持续承诺</h3>
      <p>我们致力于为消费者提供更多可持续时尚选择。从精选环保面料单品到推行简约包装，蘑菇网正在一步步践行对地球的承诺。</p>
    `,
    tags: ['可持续时尚', '环保穿搭', '绿色消费', '时尚趋势'],
  },
  {
    slug: 'color-matching-guide',
    title: '配色美学：零基础学会高级感配色',
    excerpt: '「她穿什么都好看」的秘密其实在于配色。学会这些配色法则，让你的日常穿搭轻松拥有高级感。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20color%20palette%20swatches%20in%20warm%20earth%20tones%20with%20fabric%20samples%20arranged%20artistically%2C%20soft%20natural%20lighting%2C%20clean%20cream%20background%2C%20minimalist%20design%20aesthetic%2C%20editorial%20photography&width=800&height=500&seq=article-color-06&orientation=landscape',
    date: '2026-06-25',
    author: '蘑菇编辑部',
    category: '穿搭',
    content: `
      <h2>配色是穿搭的灵魂</h2>
      <p>你可能有过这样的经历：明明买了很多好看的单品，搭配在一起却总觉得差了点味道。问题的关键往往出在配色上。掌握了配色法则，即便是基础款也能穿出高级感。</p>
      
      <h3>基础配色法则</h3>
      <p><strong>同色系搭配</strong>——最不容易出错的配色方法。选择同一色系但不同深浅度的单品组合，轻松营造出和谐统一的视觉效果。比如米白上衣搭配驼色阔腿裤，温柔又有层次。</p>
      <p><strong>邻近色搭配</strong>——选择色轮上相邻的两个颜色进行搭配，既有色彩变化又不会冲突。例如橙色系上衣搭配黄色系配饰。</p>
      <p><strong>互补色搭配</strong>——色轮上相对的两种颜色搭配，效果鲜明有冲击力。但日常搭配建议降低色彩的饱和度，例如用深红色搭配柔和的绿色。</p>
      
      <h3>2026秋冬流行配色</h3>
      <p>奶油白 + 焦糖棕、鼠尾草绿 + 米杏色、深莓果红 + 燕麦灰——这些高级配色组合，让你在这个秋冬轻松成为街头焦点。</p>
    `,
    tags: ['配色美学', '色彩搭配', '穿搭技巧', '高级感穿搭'],
  },
];